import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store/store";
import { searchSelector, activeFilters, activeMobFilters } from "features/search-property/searchproperty.slice";
import useWindowSize from "hooks/useWindowSize";
import { clearSearchResult } from "features/search-result/searchresult.slice";

const Rooms: React.FC = () => {
   
    const dispatch = useAppDispatch();
    const size: any = useWindowSize();
    const { filters, mobFilters } = useAppSelector(searchSelector);
    const {t} = useTranslation();
    const updateRooms = (e: any) => {
        if ( e.target.classList.contains('inputc')) {
            const roomcount = e.target.dataset.rooms;
            let params = (size?.width > 1110 ? { ...filters } : { ...mobFilters });
            if (params.rooms) {
                let addedrooms = params.rooms.split(',');
                if (e.target.classList.contains('inputc')) {
                    if (e.target.checked) {
                        addedrooms.push(roomcount);
                    }
                    else {
                        addedrooms.splice(params.rooms.split(',').indexOf(roomcount), 1);
                    }
                }
                params['rooms'] = addedrooms.join();
            }
            else {
                params['rooms'] = roomcount;
            }

            if (size.width ? size.width > 1110 : false) {
                dispatch(clearSearchResult());
                dispatch(activeFilters(params));
            }
            else {
                dispatch(activeMobFilters(params));
            }
        }
    }
    var rooms = [...new Array(5)];
    return (
        <>
            <div>
                {rooms.map((item, index) => (
                    <label className="checkbox" onClick={(e) => { updateRooms(e) }} data-rooms={index + 1} key={index}>
                        <input type="checkbox" className="filter-checkbox inputc" onClick={(e) => { updateRooms(e) }} data-rooms={index + 1} />
                        {index + 1} {t("common.bedroom")}
                    </label>
                ))}
                <label className="checkbox" onClick={(e) => { updateRooms(e) }} data-rooms={"studio"} key={"studio"}>
                    <input type="checkbox" className="filter-checkbox inputc" onClick={(e) => { updateRooms(e) }} data-rooms={"studio"} />
                    {t("common.studio")}
                </label>
            </div>
        </>
    );
};

export default Rooms;
